import React, { FC } from "react";

import s from "./LicenseStatusDot.less";

interface IProps {
  color: "green" | "yellow" | "red";
}

const LicenseStatusDot: FC<IProps> = ({ color }) => (
  <span className={s.dot} data-color={color} />
);

export default LicenseStatusDot;
